import ApiService from "../../ApiService";

const ArticleService = {
    loadScreenView: (id, successCallback, failureCallback) => {
        ApiService.post("/mobile/homework/unit/details", { id }, successCallback, failureCallback);
    },
};

export default ArticleService;